export default __webpack_public_path__ + "static/media/SIW200H_M050_W00.df22fa2d.webp";